import dayjs from 'dayjs'

const generateMockFluidIntakeData = () => {
  const today = dayjs()
  const dates = []

  for (let i = 7; i >= 0; i--) {
    const date = today.subtract(i, 'day')
    dates.push({
      date: date.format('YYYY-MM-DD'),
      intakeTarget: i < 4 ? 2000 : 3200
    })
  }

  return [
    {
      residentId: '643cf337c80dd66dcee87d7e',
      dates
    }
  ]
}

export const mockFluidIntakeData = generateMockFluidIntakeData()
